/**
 * ACF field `hidden`: when true, course is omitted from the public courses directory only.
 */

/** @param {unknown} course */
export function isCourseHiddenFromList(course) {
  const v = course?.acf?.hidden;
  if (v === true || v === 1) return true;
  if (v === '1' || (typeof v === 'string' && v.trim().toLowerCase() === 'true')) return true;
  return false;
}

/** @param {unknown[]|null|undefined} courses */
export function filterPublicCourses(courses) {
  if (!Array.isArray(courses)) return [];
  return courses.filter((c) => !isCourseHiddenFromList(c));
}
